function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "user-left",
  d: "M19,19a1.06,1.06,0,0,1-2.11,0V17a3.09,3.09,0,0,0-3.17-3H5.28a3.09,3.09,0,0,0-3.17,3v2a1,1,0,0,1-1,1A1,1,0,0,1,0,19V17a5.14,5.14,0,0,1,5.28-5h8.44A5.14,5.14,0,0,1,19,17ZM8.5,11A5.5,5.5,0,1,1,14,5.5,5.5,5.5,0,0,1,8.5,11Zm0-2.2A3.3,3.3,0,1,0,5.2,5.5,3.3,3.3,0,0,0,8.5,8.8Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "user-right",
  d: "M25,19a1,1,0,1,1-2,0V17A3,3,0,0,0,20.75,14,1,1,0,0,1,20,12.76,1,1,0,0,1,21.24,12h0A5.06,5.06,0,0,1,25,17v2ZM15.75,1.82A.93.93,0,0,1,15,.69,1,1,0,0,1,16.25,0,4.69,4.69,0,0,1,20,4.5,4.7,4.7,0,0,1,16.25,9,1,1,0,0,1,15,8.31a.93.93,0,0,1,.72-1.13A2.81,2.81,0,0,0,18,4.5,2.8,2.8,0,0,0,15.75,1.82Z"
});

function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.26d58a44.svg";
export { ForwardRef as ReactComponent };